export { default } from './EvInspectionBanner';
